<section class="ListView">
  <div class="container">
    <h4
      class="ListView__Title"
      [ngClass]="{
        'ListView__Title--HideForMobile': config?.isTitleWithMobileSearch,
      }"
      [innerHTML]="title"
    ></h4>
    @if (hasTabs) {
      <div class="ListView__tabs">
        <tabs
          (tabSelected)="setActiveTab($event)"
          [tabLabels]="config.tabs.tabLabels"
        ></tabs>
      </div>
    }

    @if (description) {
      <p
        reconcileHtmlLink
        class="ListView__description t-html"
        [innerHTML]="description | safeHtml"
      ></p>
    }

    <div
      class="ListView__Actions"
      [ngClass]="{
        ListView__Actions__TitleWithSearch: config?.isTitleWithMobileSearch,
      }"
    >
      @if (config?.isTitleWithMobileSearch) {
        <h4 class="ListView__Title--Mobile" [innerHTML]="title"></h4>
      }
      <div class="u-flex u-justifyBetween">
        <p class="ListView__value">{{ filtersFormValueString }}</p>
        <icon
          (click)="openMobileFilters()"
          dataClickEvent
          aria-label="Open mobile filters"
          [config]="{ type: 'link' }"
          [name]="filters?.mobileIcon || 'tune'"
        >
        </icon>
      </div>
    </div>

    @if (filters && !isMobileView) {
      <div class="ListView__filters" role="region" aria-label="filters">
        <lib-list-view-filters-form
          [filters]="filters"
          [filtersForm]="filtersForm"
          [isMobileView]="isMobileView"
          (filtersApplied)="applyFilters()"
          (filtersCleared)="clearFilters()"
          (formCreated)="handleFormCreated()"
          (typeAheadOptionSelected)="handleTypeaheadOptionSelected($event)"
        ></lib-list-view-filters-form>
      </div>
    }

    <ng-content select=".SpendingAccountCard"></ng-content>

    @if (notes) {
      <div class="ListView__notes">
        <message-banner
          [config]="{
            icon: 'info',
            type: 'info',
            message: notes,
          }"
        >
        </message-banner>
      </div>
    }

    @if (config?.datagridDescription) {
      <div class="ListView__Datagrid__Description">
        <p [innerHTML]="config.datagridDescription"></p>
      </div>
    }

    @if (export) {
      <div class="ListView__export">
        <zip-button
          [config]="export"
          [disabled]="disableExportButton"
          (zipButtonClicked)="exportDatagrid(datagrid.exportFileType)"
        >
        </zip-button>
      </div>
    }
    <ng-content select="[exportLoader]"></ng-content>

    @if (exportDropdown) {
      <div class="ListView__exportDropdown">
        <action-button
          [actionButtonMetaConfig]="exportDropdown"
          [isDisabled]="disableExportButton"
          (actionLinkClicked)="handleActionLinkClicked($event)"
        ></action-button>
      </div>
    }

    @if (datagrid) {
      <div class="ListView__datagrid" #theDatagrid>
        <datagrid
          (actionClicked)="handleClickAction($event)"
          (datagridRowSelected)="setActiveRow($event)"
          (sortClicked)="handleDataGridSort($event)"
          (sortHeaderClicked)="handleDataGridSortHeader($event)"
          [sortOrder]="currentSortOrder"
          [config]="datagrid"
          [data]="data"
          [hasAnErrorOccurred]="hasAnErrorOccurred"
          [isLoading]="config.dataIsLoading"
        >
        </datagrid>
      </div>
    }

    @if (paginator?.totalPages > 1 && data?.length > 0) {
      <div class="ListView__paginator">
        <paginator (pageSelected)="setCurrentPage($event)" [config]="paginator">
        </paginator>
      </div>
    }
  </div>
</section>

<lib-list-view-mobile-filters
  [areMobileFiltersOpen]="areMobileFiltersOpen"
  [filters]="filters"
  [filtersForm]="filtersForm"
  (cancelFiltersClicked)="cancelMobileFiltersOpen()"
  (applyFiltersClicked)="applyFilters()"
  (clearFiltersClicked)="clearFilters()"
  (typeAheadOptionSelected)="handleTypeaheadOptionSelected($event)"
></lib-list-view-mobile-filters>

<div class="ListView__export-modal--error">
  <lib-list-view-export-error-modal
    [exportError]="exportError"
    [showErrorModal]="showErrorModal"
    (modalClosed)="closeErrorModal()"
  ></lib-list-view-export-error-modal>
</div>
